import { Guid } from "@/types"
import { Purpose } from "config/constants"
import Address, { IAddressDto } from "./Address"
import { ReservationStatus } from "./Reservation"
import CustomerExtended, { ICustomerExtendedDto } from "./CustomerExtended"
import ReservationTime, { IReservationTimeDto } from "./ReservationTime"
import RentToBuyChange, { IGetRentToBuyChangeDTO } from "./RentToBuyChange"

export interface IGetRentToBuyEventDTO {
    reservationId: Guid
    number: string
    status: ReservationStatus
    time: IReservationTimeDto
    assetId?: Guid | null
    assetCount: number
    address: IAddressDto
    purpose: Purpose
    customer: ICustomerExtendedDto
    approved: boolean
    changes: IGetRentToBuyChangeDTO[]
}

export default class RentToBuyEvent {
    reservationId: Guid
    number: string
    status: ReservationStatus
    time: ReservationTime
    assetId?: Guid
    assetCount: number
    address: Address
    purpose: Purpose
    customer: CustomerExtended
    approved: boolean
    changes: RentToBuyChange[]

    constructor(dto: IGetRentToBuyEventDTO) {
        this.reservationId = dto.reservationId
        this.number = dto.number
        this.status = dto.status
        this.time = new ReservationTime(dto.time)
        this.assetId = dto.assetId ?? undefined
        this.assetCount = dto.assetCount
        this.address = new Address(dto.address)
        this.purpose = dto.purpose
        this.customer = new CustomerExtended(dto.customer)
        this.approved = dto.approved
        this.changes = dto.changes.map(change => new RentToBuyChange(change))
    }

    get hasNotApprovedChanges(): boolean {
        return this.changes.some(change => !change.approved)
    }
}
